import { poll } from 'lib/poll';
import { millisecond } from 'config/constants';
import { DateRange, LatestRef } from './types';
import { toCalendarDateFormat } from 'lib/utils';
import { SelfServiceAPI } from 'apis';

export const createQuote = async (ref: LatestRef, { startDate, endDate }: DateRange) => {
  const { booking, setState } = ref.current;

  setState((state) => ({ ...state, startDate, endDate, stage: 'QUOTING' }));

  let amendmentId: string;
  try {
    const createResult = await SelfServiceAPI.createDateAmendment({
      bookingId: booking.id,
      checkIn: toCalendarDateFormat(startDate),
      checkOut: toCalendarDateFormat(endDate),
    });
    amendmentId = createResult.id;
  } catch {
    throw new Error('Failed creating amendment');
  }

  const quotedResult = await poll({
    requestFn: () => SelfServiceAPI.getAmendment({ bookingId: booking.id, amendmentId }),
    isFinished: (result) => result.amendment.state !== 'QUOTING',
    timeoutMs: millisecond.MINUTE,
  });

  const { amendment } = quotedResult;

  setState((state) => ({ ...state, stage: amendment.state === 'QUOTED' ? 'REVIEW' : 'EDIT' }));

  return amendment;
};
